import React, { ReactNode } from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './StatisticInfoCard.module.scss';
import { DiffPercentLabel } from '../ui-components/DiffPercentLabel/DiffPercentLabel';

type StatisticInfoCardProps = {
  title: ReactNode;
  value: string | number;
  comparingPercentage?: number;
  period?: string;
};

const StatisticInfoCard = ({
  title,
  value,
  comparingPercentage,
  period,
}: StatisticInfoCardProps) => {
  return (
    <Surface variant="outlined" className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.valueContainer}>
        <p className={classes.value}>{value}</p>
        <p className={classes.comparingInfo}>
          {!!comparingPercentage && (
            <>
              <DiffPercentLabel percentValue={comparingPercentage} />
              {' vs '}
            </>
          )}
          {period}
        </p>
      </div>
    </Surface>
  );
};

export { StatisticInfoCard };
